import React from 'react';
import { utils, writeFile } from 'xlsx';
import { BiDownload } from 'react-icons/bi';
import ButtonSecondary from '../../atoms/ButtonSecondary/view';

const BatchExcelTemplateButton = () => {
    const handleDownload = () => {
        // Estructura esperada por useCargaMasiva.ts:
        // Fila 2 (index 1): [descripcion, document_type, document, date]
        // Fila 4+ (index 3+): [cuenta, tercero, debito, credito, detalle]
        
        const data = [
            ["DESCRIPCIÓN (Opcional)", "TIPO DOCUMENTO (Obligatorio)", "NÚMERO DOCUMENTO", "FECHA (AAAA-MM-DD)"],
            ["Ejemplo de Comprobante Masivo", "CC", "001", "2023-12-31"],
            ["CUENTA (Código)", "TERCERO (NIT/Cédula)", "DÉBITO", "CRÉDITO", "DETALLE DE LÍNEA"],
            ["110505", "123456789", 500000, 0, "Apertura de caja"],
            ["413505", "123456789", 0, 500000, "Ventas del día"]
        ];

        const worksheet = utils.aoa_to_sheet(data);
        
        // Ajustar anchos de columna para que se vea bien
        worksheet['!cols'] = [
            { wch: 30 }, // Descripcion
            { wch: 20 }, // Tipo
            { wch: 15 }, // Numero
            { wch: 15 }, // Fecha
            { wch: 15 }, // Cuenta
        ];

        const workbook = utils.book_new();
        utils.book_append_sheet(workbook, worksheet, "Comprobante");
        writeFile(workbook, "Plantilla_Carga_Masiva_Contable.xlsx");
    };

    return (
        <ButtonSecondary
            onClick={handleDownload}
            icon={<BiDownload size={16} />}
            title="Descargar Plantilla Excel"
            style={{ marginTop: '8px' }}
        />
    );
};

export default BatchExcelTemplateButton;
